import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgProject(props: RootSvgProps) {
  return (
    <RootSvg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4628_55466)">
        <path
          d="M12.2727 6.63636V16.6586L9.01954 15.26L8.40909 14.9973L7.79864 15.26L4.54545 16.6586V6.63636H12.2727ZM15.3636 2H7.62864C6.77864 2 6.09091 2.69545 6.09091 3.54545H13.8182C14.6682 3.54545 15.3636 4.24091 15.3636 5.09091V15.1364L16.9091 15.9091V3.54545C16.9091 2.69545 16.2136 2 15.3636 2ZM12.2727 5.09091H4.54545C3.69545 5.09091 3 5.78636 3 6.63636V19L8.40909 16.6818L13.8182 19V6.63636C13.8182 5.78636 13.1227 5.09091 12.2727 5.09091Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4628_55466">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
